import dynamic from 'next/dynamic';
export const TableOfContents = dynamic(() => import('./table-of-contents'));